<template>
  <i-menu class="contract-menu" mode="horizontal" theme="dark">
    <router-link class="ivu-menu-item contract-menu__contract-name" to="/app/contracts" exact>
      <icon size="24" type="ios-arrow-back" />
    </router-link>
    <router-link class="ivu-menu-item" :to="`/app/contragents/${id}/overview`">Карточка подрядчика</router-link>
    <router-link class="ivu-menu-item" :to="`/app/contragents/${id}/amendments`">ДС</router-link>
    <router-link class="ivu-menu-item" :to="`/app/contragents/${id}/acts`">Акты</router-link>
    <router-link class="ivu-menu-item" :to="`/app/contragents/${id}/payments`">Платежи</router-link>
    <router-link class="ivu-menu-item" :to="`/app/contragents/${id}/resources`">Материалы</router-link>
  </i-menu>
</template>

<script>
export default {
  computed: {
    id () {
      return this.$route.params.id
    }
  }
}
</script>

<style lang="less">
  .contract-menu {
    &.ivu-menu {
      z-index: 400;
    }

    &.ivu-menu-horizontal {
      .ivu-menu-item {
        padding: 0 10px;

        &:first-child {
          padding-left: 0;
        }
      }
    }

    &__contract-name {
      max-width: 112px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
